import { forwardRef } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Custom styles for MDAccordion
import MDAccordionRoot from "./MDAccordionRoot";

// Material Dashboard 2 PRO React contexts
import { useMaterialUIController } from "context";

// Import MUI components for Accordion functionality
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const MDAccordion = forwardRef(
  ({ color, variant, square, children, summary, details, ...rest }, ref) => {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    return (
      <MDAccordionRoot
        {...rest}
        ref={ref}
        square={square}
        ownerState={{ color, variant, square, darkMode }}
      >
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel-content"
            id="panel-header"
          >
            {summary}
          </AccordionSummary>
          <AccordionDetails>{details || children}</AccordionDetails>
        </Accordion>
      </MDAccordionRoot>
    );
  }
);

// Setting default values for the props of MDAccordion
MDAccordion.defaultProps = {
  square: false,
  color: "white",
  variant: "contained",
};

// Typechecking props for the MDAccordion
MDAccordion.propTypes = {
  square: PropTypes.bool,
  color: PropTypes.oneOf([
    "white",
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  variant: PropTypes.oneOf(["text", "contained", "outlined"]),
  summary: PropTypes.node.isRequired,
  details: PropTypes.node,
  children: PropTypes.node,
};

export default MDAccordion;